<div class="main-container" class="p-6">
  <div [formGroup]="patientDetailAddComment" class="grid grid-cols-6 gap-2">
    <mat-form-field appearance="outline" class="col-span-12" >
      <mat-label>Comment</mat-label>
      <textarea maxlength="2048" matInput formControlName="comments"  rows="10"></textarea>
      <mat-error>{{ "Required field" }}</mat-error>
    </mat-form-field>
  </div>
</div>
